const DEMO_DOMAIN_MAP: Record<string, string> = {
  parrot: "paschal",
  parakeet: "paschal",
  reindeer: "randazzo",
  hawk: "hoffmann",
  quail: "qualityplumbing",
  moose: "mistersparky",
  centipede: "certus",
  pangolin: "purcor",
  raccoon: "responsible",
  ladybug: "lvpc",
  locust: "lookoutpest",
  vampirebat: "vanterra",
  trex: "tragar",
  rhino: "ryanlawn",
};

/** Blinded Heartland enterprise portal — same data as Heartland, names masked in UI. */
export const HUMMINGBIRD_ENTERPRISE_HOST = "enterprise.hummingbird.netic.ai";
export const HEARTLAND_ENTERPRISE_HOST = "enterprise.heartland.netic.ai";
export const HUMMINGBIRD_ENTERPRISE_SLUG = "hummingbird";
export const HEARTLAND_ENTERPRISE_SLUG = "heartland";

export function isHummingbirdEnterpriseHost(rawHost: string): boolean {
  const hostOnly = (rawHost.split(":")[0] ?? "").toLowerCase().trim();
  const withoutWww = hostOnly.startsWith("www.") ? hostOnly.slice(4) : hostOnly;
  return withoutWww === HUMMINGBIRD_ENTERPRISE_HOST || withoutWww.endsWith(".hummingbird.netic.ai");
}

/** Map presentation slug `hummingbird` → DB slug `heartland` for lookups. */
export function resolveEnterpriseSlugForLookup(slug: string): string {
  return slug === HUMMINGBIRD_ENTERPRISE_SLUG ? HEARTLAND_ENTERPRISE_SLUG : slug;
}

/** Presentation slug for URLs/session when the hummingbird portal is active. */
export function presentationEnterpriseSlug(realSlug: string, hummingbird: boolean): string {
  if (hummingbird && realSlug === HEARTLAND_ENTERPRISE_SLUG) {
    return HUMMINGBIRD_ENTERPRISE_SLUG;
  }
  return realSlug;
}

/**
 * Maps demo / blinded hosts to the real account domain used in DB lookups.
 * Same idea as hawk.netic.ai → hoffmann: no separate rows, URL decides presentation.
 */
export function processUrlForDemo(lookup: string): string {
  if (isHummingbirdEnterpriseHost(lookup)) {
    return HEARTLAND_ENTERPRISE_HOST;
  }
  const subdomain = lookup.split(".")[0];
  const mapped = DEMO_DOMAIN_MAP[subdomain];
  if (mapped) {
    return lookup.replace(subdomain, mapped);
  }
  return lookup;
}

export const CENTIPEDE_DEMO_HOST = "centipede.netic.ai";

/**
 * Returns true when the current page is the centipede demo URL.
 * Pass `host` explicitly on the server; on the client, omit and we'll
 * read `window.location.hostname`.
 */
export function isCentipedeDemo(host?: string | null): boolean {
  const h = host ?? (typeof window !== "undefined" ? window.location.hostname : null);
  return h === CENTIPEDE_DEMO_HOST;
}
